export { Alphatar, type IAlphatarProps } from './alphatar';
